import { createMuiTheme } from '@material-ui/core';
import { csCZ } from '@material-ui/core/locale';

const palette = {
	primary: {
		main: '#cb2027',
	},
	secondary: {
		main: '#464646',
	},
	text: {
		primary: '#34322f',
	},
};

export const theme = createMuiTheme(
	{
		palette,
		mixins: {
			toolbar: {
				maxHeight: '75px',
				minHeight: '75px',
			},
		},
		typography: {
			fontFamily: 'Open Sans, sans-serif',
			fontWeightBold: 'lighter',
			button: {
				fontStyle: 'normal',
				fontWeight: 600,
				fontSize: '16px',
				lineHeight: '22px',
				textTransform: 'none',
			},
			h6: {
				color: '#da2128',
			},
		},
		overrides: {
			MuiLink: {
				root: {
					textTransform: 'uppercase',
					fontWeight: 600,
					fontSize: '.8125rem',
					fontFamily: 'Open Sans',
					padding: '0 20px',
				},
			},
			MuiAppBar: {
				root: {
					boxShadow: 'none',
					borderTop: '3px solid #da2128',
					borderBottom: '1px solid #da2128',
					backgroundColor: '#ffffff',
				},
			},
			MuiToolbar: {
				root: {
					backgroundColor: '#ffffff',
				},
			},
			MuiInputLabel: {
				root: {
					'&.Mui-required:not(.Mui-disabled):not(.Mui-error)': {
						color: palette.primary.main,
					},
				},
			},
			MuiInputBase: {
				root: {
					'&.Mui-disabled': {
						background: 'rgba(250,250,250)',
						color: 'rgba(0,0,0,0.7)',
					},
				},
			},
			MuiTableRow: {
				root: {
					'&.Mui-selected': {
						backgroundColor: palette.primary.main,
					},
				},
			},
			MuiButton: {
				text: {
					'& .MuiButton-startIcon': {
						color: palette.primary.main,
					},
				},
			},
			MuiCssBaseline: {
				'@global': {
					// Toastify
					'.Toastify__toast': {
						color: palette.text.primary,
						fontFamily: 'inherit',
						fontWeight: 500,
					},
					'.Toastify__close-button': {
						color: palette.primary.main,
						opacity: 1,
					},
					// Text styles
					'h1,h2,h3,h4,h5,p': {
						color: palette.text.primary,
						fontStyle: 'normal',
						fontWeight: 'normal',
						fontSize: 14,
						lineHeight: 1.4,
						margin: 0,
					},
				},
			},
		},
	},
	csCZ,
);
